import { render } from "./ReqField.vue?vue&type=template&id=9baf1080"
import script from "./ReqField.vue?vue&type=script&lang=js"
export * from "./ReqField.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ASMPP\\ASMPP_VUE\\asmpp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__